/* Page to edit a Callsheet
 * Contains the SchedulePage component and the AddCast and
   AddBackGround form components to add the cast and BG call times
   These are seperate forms to the main Callsheet form
 * Contains the Form components to add each department crew call times:
   AddProduction, AddCamera, AddCastingAD, AddLocations, AddWardrobe, AddScriptCater, AddElectricGrip,
   AddMakeup, AddArt, AddSoundTransport, AddStunts and AddPostAdditional 
 * The sidebyside value allows the schedule and the addCast components 
   to be viewed on the same page */
import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Dropdown } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import { useHistory, useParams } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import TopBox from "../../components/TopBox";
import { useRedirect } from "../../hooks/Redirect";
import AddCast from "./CallsheetAddCast2";
import CallsheetAddCrew2 from "./CallsheetAddCrew2";
import SchedulePage from "./callsheetSchedule2/SchedulePage2";
import AddBackGround from "./CallsheetAddBackGround2";

import InformationEdit from "./info2/InformationEdit2";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import toast from "react-hot-toast"; 
import styles from "../../styles/Callsheets.module.css";
import btnStyles from "../../styles/Button.module.css";
import axios from "axios";

const CallsheetEditPage2 = () => {
   // NEEDS TO BE CHANGED TO "second" - just swap with line below
  // const dept = "casting";
  // const dept = "second";
  const host = useHostName();
  useRedirect();
  const [errors, setErrors] = useState({});
  const [hospitals, setHospitals] = useState({ results: [] })
  const { id } = useParams();
  const history = useHistory();
  const [showSchedule, setShowSchedule] = useState(false);
  const [showAddCrew, setShowAddCrew] = useState(false);
  const [showAddCast, setShowAddCast] = useState(false);
  const [showAddBg, setShowAddBg] = useState(false);
  const [showSideBySide, setShowSideBySide] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const queryString = window.location.search;
  const [charactersList, setCharactersList] = useState([]);
  const [crewList, setCrewList] = useState([]); 
  const [days, setDays] = useState([]);
  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  // eslint-disable-next-line
  const project = params.get("project");
  // eslint-disable-next-line
  const episodeTitle = params.get("episodeTitle");
  // eslint-disable-next-line
  const [dayData, setDayData] = useState({ results: [] });
  const [scenes, setScenes] = useState({ results: [] });
  const [callsheet_id, setCallsheet_id] = useState({ results: [] });
  const [dataDay, setDataDay] = useState("");
  const [dataDate, setDataDate] = useState("");

  const [showInfo, setShowInfo] = useState(false);

  // main callsheet data
  const [postData, setPostData] = useState({
    weather_location: "",
    location_2_name: "",
    location_3_name: "",
    location_4_name: "",
    unit_call: "",
    talent_call: "",
    shoot_call: "",
    breakfast: "",
    lunch: "",
    wrap: "",
    basecamp_name: "",
    basecamp_address: "",
    basecamp_parking_n_notes: "",
    location_1_name: "",
    location_5_name: "",
    location_1_address: "",
    location_2_address: "",
    location_3_address: "",
    location_4_address: "",
    location_5_address: "",
    location_1_parking_n_notes: "",
    location_2_parking_n_notes: "",
    location_3_parking_n_notes: "",
    location_4_parking_n_notes: "",
    location_5_parking_n_notes: "",
    hospital_address_line_4: "",
    important_info: "",
    transport_info: "",
    department_info: "",
  });

  const {
    unit_call,
    talent_call,
    shoot_call,
    breakfast,
    lunch,
    wrap,
    basecamp_name,
    basecamp_address,
    basecamp_parking_n_notes,
    location_1_name,
    location_2_name,
    location_3_name,
    location_4_name,
    location_5_name,
    location_1_address,
    location_2_address,
    location_3_address,
    location_4_address,
    location_5_address,
    location_1_parking_n_notes,
    location_2_parking_n_notes,
    location_3_parking_n_notes,
    location_4_parking_n_notes,
    location_5_parking_n_notes,
    hospital_address_line_4,
    weather_location,
    important_info,
    transport_info,
    department_info,
  } = postData;

  // hospital data
  const [postData2, setPostData2] = useState({
      nearest_hospital: "",
      hospital_address_line_1: "",
      hospital_address_line_2: "",
      hospital_address_line_3: "",
      });
    
  const {
      nearest_hospital,
      hospital_address_line_1,
      hospital_address_line_2,
      hospital_address_line_3,
  } = postData2;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  // 1. MAIN CALLSHEET REQUESTS - NEED 2ND UNIT PARA 
  useEffect(() => {
    const handleMount = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [
            { data: dayGet },
            { data: scenesdata },
            { data: callsheetdata },
            { data: daysData },
          ] = await Promise.all([
            axiosReq.get(`/days/${id}/?is_second_unit=true`),
            axiosReq.get(`/schedule/scenes/?day_id=${id}&is_second_unit=true`),
            await axiosReq.get(`/callsheetsnew/?day_id=${id}&is_second_unit=true`),
            axiosReq.get(`days/`),
          ]);
          const {
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          } = callsheetdata.results[0];
          setCallsheet_id(callsheetdata.results[0].id);
          setPostData2({
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
          });
          setPostData({
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          });
          setDayData({ results: [dayGet] });
          setScenes(scenesdata);
          setDataDay(dayGet.day);
          setDataDate(dayGet.date);
          setDays(daysData);
          setHasLoaded(true);
        } else {
          const [
            { data: dayGet },
            { data: scenesdata },
            { data: callsheetdata },
            { data: daysData },
          ] = await Promise.all([
            axiosInstance.get(
              `${localStorage.getItem("projectSlug")}/days/${id}/?is_second_unit=true`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
              )}/schedule/scenes/?day_id=${id}&is_second_unit=true${
                epi ? `&episode_ids=${epi}` : ""
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            await axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
              )}/callsheetsnew/?day_id=${id}${
                epi ? `&episode_ids=${epi}` : ""
              }&is_second_unit=true`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            await axiosInstance.get(
            // if epi is present, add it to the query string
            `${localStorage.getItem(
              "projectSlug"
            )}/days/?is_second_unit=true${epi ? `&episode_ids=${epi}` : ""}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem(
                  "accessToken"
                )}`,
              },
              withCredentials: true,
            }
          ),
          ]);
          const {
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          } = callsheetdata.results[0];
          setCallsheet_id(callsheetdata.results[0].id);
          setPostData2({
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
          });
          setPostData({
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          });
          setDayData({ results: [dayGet] });
          setScenes(scenesdata);
          setDataDay(dayGet.day);
          setDataDate(dayGet.date);
          setDays(daysData);
          setHasLoaded(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (host === CLIENT_PROGRAM_HOSTNAME) {
      handleMount();
    } else {
      if (localStorage.getItem("accessToken")) {
        handleMount();
      }
    }
    // eslint-disable-next-line
  }, [id]);

  const fetchCharacters = async () => {
    try {
      const host = window.location.hostname;
      let data;

      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axios.get("characters/");
        data = response.data;
        console.log(data)
      } else {
        const response = await axios.get(
          `${localStorage.getItem("projectSlug")}/characters/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        data = response.data;
      }
      setCharactersList(data.results || []); // Ensure only results are stored
    } catch (err) {
      console.error("Error fetching characters:", err);
    }
  };

  useEffect(() => {
    fetchCharacters();
  }, []);

  // Hospitals request
    const fetchHospitals = async () => {
          try {
            if (host === CLIENT_PROGRAM_HOSTNAME) {
              const { data } = await axiosReq.get(`/masters/hospitals/`)
              setHospitals(data)
            } else {
              const response = await axiosInstance.get(
                `${localStorage.getItem(
                  "projectSlug"
                )}/masters/hospitals/`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                  },
                  withCredentials: true,
                }
              )
              if (response?.success === false) {
                throw response.error;
              }
              const { data } = response;
              // console.log(data)
              setHospitals(data)
              setHasLoaded(true)
            }
          } catch (err) {
            console.log(err)
            const backendError =
              err?.response?.data?.error ||
              err?.response?.data?.detail ||
              "Failed to load hospitals.";
            toast.error(backendError);
            if (err.response?.status !== 401) {
              setErrors(err.response?.data || { detail: [backendError] })
              setHasLoaded(true)
            }
          }
        }
  
    useEffect(() => {
      fetchHospitals();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /* Function to set hospital from the dropdown */
    const setData = (hospital) => {
    const hosname = hospital.name || "";
    const hosadd1 = hospital.address_line_1 || "";
    const hosadd2 = hospital.address_line_2 || "";
    const hosadd3 = hospital.address_line_3 || "";

    setPostData2({
      nearest_hospital: hosname,
      hospital_address_line_1: hosadd1,
      hospital_address_line_2: hosadd2,
      hospital_address_line_3: hosadd3,
    });
  };

  // Fetch Crew Function
  const fetchCrew = async () => {
    try {
      const host = window.location.hostname;
      let data;

      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axios.get(
          `/extracrewinfo/?is_second_unit=true`
        );
        data = response.data;
        console.log(data)
      } else {
        const response = await axios.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/extracrewinfo/?is_second_unit=true`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        data = response.data;
      }
      setCrewList(data.results || []); // Ensure only results are stored
    } catch (err) {
      console.error("Error fetching crew:", err);
    }
  };

  // Fetch crew when component mounts
  useEffect(() => {
    fetchCrew();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    // info
    formData.append("day_id", id);
    formData.append("episode", epi);
    formData.append("day", dataDay);
    formData.append("date", dataDate);
    formData.append("unit_call", unit_call);
    formData.append("talent_call", talent_call);
    formData.append("shoot_call", shoot_call);
    formData.append("breakfast", breakfast);
    formData.append("lunch", lunch);
    formData.append("wrap", wrap);
    formData.append("basecamp_name", basecamp_name);
    formData.append("basecamp_address", basecamp_address);
    formData.append("basecamp_parking_n_notes", basecamp_parking_n_notes);
    formData.append("location_1_name", location_1_name);
    formData.append("location_2_name", location_2_name);
    formData.append("location_3_name", location_3_name);
    formData.append("location_4_name", location_4_name);
    formData.append("location_5_name", location_5_name);
    formData.append("location_1_address", location_1_address);
    formData.append("location_2_address", location_2_address);
    formData.append("location_3_address", location_3_address);
    formData.append("location_4_address", location_4_address);
    formData.append("location_5_address", location_5_address);
    formData.append("location_1_parking_n_notes", location_1_parking_n_notes);
    formData.append("location_2_parking_n_notes", location_2_parking_n_notes);
    formData.append("location_3_parking_n_notes", location_3_parking_n_notes);
    formData.append("location_4_parking_n_notes", location_4_parking_n_notes);
    formData.append("location_5_parking_n_notes", location_5_parking_n_notes);
    formData.append("nearest_hospital", nearest_hospital);
    formData.append("hospital_address_line_1", hospital_address_line_1);
    formData.append("hospital_address_line_2", hospital_address_line_2);
    formData.append("hospital_address_line_3", hospital_address_line_3);
    formData.append("hospital_address_line_4", hospital_address_line_4);
    formData.append("weather_location", weather_location);
    formData.append("important_info", important_info);
    formData.append("transport_info", transport_info);
    formData.append("department_info", department_info);
    formData.append("is_second_unit", "true");
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.put(
          `/callsheetsnew/${callsheet_id}/`,
          formData
        ); 
        toast.success(`Callsheet Updated`);
        history.goBack();
      } else {
        await axiosInstance.put(
          `${localStorage.getItem(
            "projectSlug"
          )}/callsheetsnew/${callsheet_id}/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        ); 
        toast.success(`Callsheet Updated Successfully!`);
        history.goBack();
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const infoFields = (
    <div className={`pb-3 px-3 text-center ${styles.White }`}>
      {/* TIMES   */}
      <div>
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      TIMES
      </h5>
      </Col>
      </Row>  
      {/* Unit call - Talent call Shoot call */}
      <Row>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="unit_call" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Unit Call</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="unit_call"
                value={unit_call}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.unit_call?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="talent_call" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Talent Call</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="talent_call"
                value={talent_call}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.talent_call?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="shoot_call" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Shoot Call</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="shoot_call"
                value={shoot_call}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.shoot_call?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      {/* breakfast - lunch - wrap */}
      <Row>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="breakfast" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Breakfast</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="breakfast"
                value={breakfast}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.breakfast?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="lunch" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Lunch</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="lunch"
                value={lunch}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.lunch?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="wrap" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Est. Wrap</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="wrap"
                value={wrap}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.wrap?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      <hr/>
      {/* Contact INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      CONTACT INFO
      </h5>
      </Col>
      </Row> 
      <Row >
      <Col md={6} className=" p-0 p-md-2 mt-2">
      <div className="d-flex justify-content-center">
      <Form.Group controlId="location_1_address" className={`${styles.Width} `}  >
          <Form.Label className={`${styles.BoldScene}`} >2nd Unit Director Name</Form.Label>
          <Form.Control 
            className={`${styles.Input}`}
            type="text"
            name="location_1_address"
            value={location_1_address}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.location_1_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </div>
      </Col>
      <Col md={6} className=" p-0 p-md-2 mt-2">
      <div className="d-flex justify-content-center">
      <Form.Group controlId="location_2_address" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >2nd Unit Director Mobile</Form.Label>
          <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_2_address"
              value={location_2_address}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.location_2_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </div>
      </Col>
      </Row>
      {/* line 2 */}
      <Row >
      <Col md={6} className=" p-0 p-md-2 mt-2">
      <div className="d-flex justify-content-center">
      <Form.Group controlId="location_3_address" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >2nd Unit 1st AD Name</Form.Label>
          <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_3_address"
              value={location_3_address}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.location_3_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </div>
      </Col>
      <Col md={6} className=" p-0 p-md-2 mt-2"> 
      <div className="d-flex justify-content-center">
      <Form.Group controlId="location_4_address" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >2nd Unit 1st AD Mobile</Form.Label>
          <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_4_address"
              value={location_4_address}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.location_4_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </div>
      </Col>
      </Row>
      </div> 
      <hr/>
      {/* Wea INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      WEATHER
      </h5>
      </Col>
      </Row>
      {/* weather using location_2_name */}
      <Row className="my-3">
      <Col className="d-flex justify-content-center"
       xs={{span: 10, offset: 1}} md={{span: 8, offset: 2}}>
        <Form.Group controlId="location_2_name" className={`${styles.Width95} `}  >
        <Form.Label className={`${styles.BoldScene}`} >Weather
            </Form.Label>
            <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_2_name"
              value={location_2_name}
              onChange={handleChange}
                />
        </Form.Group>
        {errors?.location_2_name?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      </Row>
      {/* rise using location_3_name - set using location_4_name */}
      <Row className="my-3">
      <Col className="d-flex justify-content-center" xs={6} >
          <Form.Group controlId="location_3_name" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Sunrise
              </Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="location_3_name"
                value={location_3_name}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_3_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col className="d-flex justify-content-center" xs={6} >
        <Form.Group controlId="location_4_name" className={`${styles.Width95} `}  >
        <Form.Label className={`${styles.BoldScene}`} >Sunset
            </Form.Label>
            <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_4_name"
              value={location_4_name}
              onChange={handleChange}
                />
        </Form.Group>
        {errors?.location_4_name?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      </Row>
      </div> 
      <hr/>
      {/* hos INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center ${styles.SubTitleC }`} >
      NEAREST HOSPITAL
      </h5>
      </Col>
      </Row>
      <p className={`${styles.SmallSize} text-center py-2`}
      style={{fontStyle: 'italic'}}>Select the Nearest Hospital 
        from the Dropdown. Add Hospitals to the Dropdown on the Callsheets page.
      </p>
      {/* hospitals  Dropdown d-flex justify-content-center */}
      <Row className="d-flex align-items-center">
      <Col md={6} className=" p-2">
      <Dropdown className={`${styles.Add }`}>
          <Dropdown.Toggle variant="info" id="dropdown-basic" size="sm">
            HOSPITALS
          </Dropdown.Toggle>
          <Dropdown.Menu className={`pt-1 pl-2 ${styles.DropButt}`}>
          {hospitals.results.length && (
                hospitals.results.map((hospital) => (
                  <Dropdown.Item onClick={() => setData(hospital) } 
                  key={hospital.id} >{hospital.name}</Dropdown.Item>
                ) )) }
          </Dropdown.Menu>
      </Dropdown>
      </Col>
      <Col xs={{span: 8, offset: 2}} md={{span: 3, offset: 1}} className="p-2">
        <p className={``}>
        {nearest_hospital}
        </p>
        <hr className={`mt-0 mb-0 ${styles.HRGold2 }`}/>
        </Col>
      </Row>
      </div> 
      <hr/>
      {/* LOCATIONS */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      BASECAMP
      </h5>
      </Col>
      </Row>
      <div> 
      <Row className="my-2" >
      <Col >
      <p className={`${styles.SmallSize } mb-1`} style={{fontStyle: 'italic'}}>
      Filming Locations are automatially added from the Schedule. 
      </p>
      </Col>
      </Row>
      </div>
      <div> 
      <Row className="mb-2">
      <Col xs={12} md={{span: 6, offset: 3}} className="d-flex justify-content-center pt-2 p-md-2">
      <Form.Group controlId="basecamp_name" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Basecamp Name</Form.Label>
          <Form.Control 
            className={`${styles.Input}`}
            type="text"
            name="basecamp_name"
            value={basecamp_name}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.basecamp_name?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      <Row className="mb-2 mt-3">
      <Col xs={12} md={6}  className="d-flex justify-content-center pt-2 p-md-2">
      <Form.Group controlId="basecamp_address" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Basecamp Address</Form.Label>
          <Form.Control 
            className={`${styles.InputScene}`}
            type="text"
            as="textarea"
            rows={1}
            name="basecamp_address"
            value={basecamp_address}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.basecamp_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      <Col xs={12} md={6}  className="d-flex justify-content-center pt-2 p-md-2">
      <Form.Group controlId="basecamp_parking_n_notes" className={`${styles.Width95} `}  >
          <Form.Label className={`d-none d-md-block ${styles.BoldScene}`}>Basecamp Parking and Notes</Form.Label>
          <Form.Label className={`d-md-none ${styles.BoldScene}`}>Basecamp Notes</Form.Label>
          <Form.Control 
            className={`${styles.InputScene}`}
            as="textarea"
            rows={1}
            type="text"
            name="basecamp_parking_n_notes"
            value={basecamp_parking_n_notes}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.basecamp_parking_n_notes?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      </div>
      {/* 1st location Name */}
      {/* <Row className="my-2">
        <Col className="d-flex justify-content-center" xs={{span: 6, offset: 3}} >
          <Form.Group controlId="location_1_name" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >1st Location's Name
              </Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="location_1_name"
                value={location_1_name}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_1_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row> */}
      </div>
      <hr/>
      {/* DEPARTMENT & IMPORTANT INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      INFORMATION
      </h5>
      </Col>
      </Row>  
      {/* department info */}
      <Row className="mt-2">
      <Col md={{span: 10, offset: 1}} className="d-flex justify-content-center p-0 p-md-2 ">
          <Form.Group controlId="department_info" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Shoot Info</Form.Label>
              <Form.Control 
                className={`${styles.InputScene}`}
                as="textarea"
                rows={1}
                type="text"
                name="department_info"
                value={department_info}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.department_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row>
      {/* impor - transport info */}
      <Row className="mt-2">
      <Col md={6} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="important_info" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Important Info</Form.Label>
              <Form.Control 
                className={`${styles.InputScene}`}
                as="textarea"
                rows={1}
                type="text"
                name="important_info"
                value={important_info}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.important_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col md={6} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="transport_info" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Transport Info</Form.Label>
              <Form.Control 
                className={`${styles.InputScene}`}
                type="text"
                as="textarea"
                rows={1}
                name="transport_info"
                value={transport_info}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.transport_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row>
      </div>
      <hr/>
      {/* WALKIE CHANNELS */}
      {/* <div className="mt-5">
      <Row>
            <Col md={{span: 10, offset: 1}} >
            <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
            WALKIES CHANNELS
            </h5>
            </Col>
      </Row>  
      <Row className="pt-2">
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_production" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Production</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_production"
              value={walkie_channel_production}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_production?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_open" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Open</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_open"
              value={walkie_channel_open}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_open?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_transportation" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Transport</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_transportation"
              value={walkie_channel_transportation}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_transportation?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_art_dept" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Art Dept</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_art_dept"
              value={walkie_channel_art_dept}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_art_dept?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <hr className="mb-1"/>
      <Row>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_rollover" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Rollover</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_rollover"
              value={walkie_channel_rollover}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_rollover?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_camera" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Camera</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_camera"
              value={walkie_channel_camera}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_camera?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_electric" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Electric</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_electric"
              value={walkie_channel_electric}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_electric?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_grip" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Grip</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_grip"
              value={walkie_channel_grip}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_grip?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>  */}
      <hr/>
      <Row>
      <Col md={6} >
      {/* ADVANCED SCHEDULE */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center ${styles.SubTitleC }`} >
      ADVANCED SCHEDULE
      </h5>
      </Col>
      </Row>
      <p className={`${styles.SmallSize } pt-2`} style={{fontStyle: 'italic'}}>Use the Shoot Days Dropdown to select the Advanced Schedule Day.</p>
      <Row >
      <Col md={{span: 10, offset: 1}} className="d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="hospital_address_line_4" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`} >Select Shoot Day</Form.Label>
              <Form.Control as="select"
                name="hospital_address_line_4"
                className={styles.Input}
                value={hospital_address_line_4}
                onChange={handleChange}
                aria-label="location select">
                  <option  ></option>
                {days.results?.length && (
                    days.results.map((day) => (
                      <option key={day.id} value={day.id} >{`Shoot Day ${day.day}`}</option>
                    ) )) }
              </Form.Control>
          </Form.Group>
          {errors?.hospital_address_line_4?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row> 
      </div>
      <hr/>
      </Col>
      <Col md={6} >
      {/* COUNTRY INFO using location_5_name */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
        <h5 className={`text-center ${styles.SubTitleC }`} >
      OTHER COUNTRY UNITS
      </h5>
      </Col>
      </Row> 
      <p className={`${styles.SmallSize } my-2`} style={{fontStyle: 'italic'}}>
      Enter the relevant city or country name here <span className={`${styles.Red}`}>ONLY</span> if the Shoot is in a 
      different country to the main Shoot
      </p>
      {/* Different Country */}
      <Row className="my-2">
        <Col className="d-flex justify-content-center" xs={{span: 6, offset: 3}} >
          <Form.Group controlId="location_5_name" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >City/Country Name
              </Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="location_5_name"
                value={location_5_name}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_5_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      </div> 
      </Col>
      </Row>
      <hr/>
    </div>
  )

  const buttons = (
    <div className={`text-center py-4 mb-3 mt-4 ${styles.White }`} >    
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`ml-3 ${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3 `} type="submit">
        Submit
      </Button>
    </div>
  );

  return (
    <div>
      {hasLoaded ? (
        <>
          <TopBox
            second="2ND UNIT"
            title="Callsheet Edit"
            title3={`Day ${dataDay} - ${dataDate} `}
          />
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} mt-1`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
          <Button
            className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            INFO
          </Button>
          {!showInfo ? "" : <InformationEdit />}
          <div className="text-center d-none d-md-block "></div>
          {/* cast bg */}
          <div className= {`mb-4 ${styles.White }`}>
          <h5 className={`text-center py-1 mt-2 mr-2 pr-5 ${styles.SubTitle }`} >
            <span className="float-left pl-2" >Section 1</span>
          CREW, CAST & BG/STUNTS FORMS</h5> 
          <Row className="text-center">
          <Col xs={12} md={{span: 8, offset: 2 }} >
          <p className={`${styles.SmallSize } pt-2`} style={{fontStyle: 'italic'}}>
          Add/Edit Crew, Cast and BG/Doubles/Stunts Calls here. These forms are separate from the Main 
          Callsheet form below.
          </p>
          </Col>
          </Row>
          {/* crew cast buttons */}
          <Row className='text-center'>
          {/* crew */}
          <Col className='text-center mx-0 px-0' xs={4} sm={4}>
          <Button
            className={`mt-3 px-4 px-md-5 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowAddCrew(showAddCrew => !showAddCrew)} >Add Crew
          </Button>
          </Col>
          {/* cast */}
          <Col className='text-center mx-0 px-0' xs={4} sm={4}>
          <Button
            className={`mt-3 px-4 px-md-5 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowAddCast(showAddCast => !showAddCast)} >Add Cast
          </Button>
          </Col>
          {/* BG */}
          <Col className='text-center mx-0 px-0' xs={4} sm={4} >
          <Button
            className={`my-3 px-3 px-md-4  ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowAddBg(showAddBg => !showAddBg)} >
              Add BG/Stunts
          </Button>
          </Col>
          </Row>
          {/* schedules button */}
          <Row className='text-center'>
          <Col xs={6} >
          <Button
            className={`mt-3 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowSchedule(showSchedule => !showSchedule)} >View Schedule
          </Button>
          </Col>
          {/* Schedule and Cast Forms */}
          <Col xs={6} 
          className='text-center mx-0 px-0'  >
          <Button
            className={`my-3 px-3 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowSideBySide(showSideBySide => !showSideBySide)} >
              Schedule and Talent Forms
          </Button>
          </Col>
          </Row>
          {/* schedule */}
          <div className="mt-3">
          {!showSchedule ? (
          ""
          ) : (
          <>
          <SchedulePage
          setShow={setShowSchedule}
          scenes={scenes} />
          </>
          ) }
          </div>
          {/* add crew */}
          <div>
          {!showAddCrew ? (
          ""
          ) : (
          <CallsheetAddCrew2 id={id} setShow={setShowAddCrew} 
          crewList={crewList}
          dataDay={dataDay} dataDate={dataDate} />
          ) }
          </div> 
          {/* add cast */}
          <div>
          {!showAddCast ? (
          ""
          ) : (
          <AddCast id={id} setShow={setShowAddCast} 
          charactersList={charactersList}
          dataDay={dataDay} dataDate={dataDate} />
          ) }
          </div> 
          {/* add bg */}
          <div>
          {!showAddBg ? (
          ""
          ) : (
          <AddBackGround 
          id={id} 
          setShow={setShowAddBg} 
          dataDay={dataDay} dataDate={dataDate} />
          ) }
          </div> 
          {/* SideBySide */}
          {!showSideBySide ? (
          ""
          ) : (  
            <div>                    
          <Row className="mx-0">
            <Col className="px-1" lg={6}>
            <SchedulePage
            showSideBySide={showSideBySide}
            setShow={setShowSideBySide}
            scenes={scenes}  />
            </Col>
            <Col lg={6} className="pt-3">
            <div>
            <AddCast 
            id={id} 
            setShow={setShowSideBySide} 
            charactersList={charactersList}
            dataDay={dataDay} dataDate={dataDate} />
            </div>
            <div className="mt-3">
            <AddBackGround 
            setShow={setShowSideBySide} 
            id={id} 
            dataDay={dataDay} dataDate={dataDate} />
              </div>
            </Col>
          </Row>  
          </div>           
          ) }
          </div>
          {/* big break */}
          <Row className='my-5 pb-5'>
          <Col xs={2} ></Col>
          <Col xs={8}>
          <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
          <hr className={`${styles.BreakBlack} my-0`}/>
          </Col>
          </Row>
          <h5 className={`text-center mt-5 mb-0 py-2 mr-3 pr-5 ${styles.SubTitle }`} >
            <span className="float-left pl-2" >Section 2</span>
          MAIN CALLSHEET FORM
          </h5> 
          <Row className={`${styles.White }`}>
          <Col md={{span: 8, offset: 2}} >
          <p className={`${styles.SmallSize } mt-2 mb-2 text-center`} style={{fontStyle: 'italic'}}>
          Add/Edit Callsheet Times, Contacts, Weather, Hospital, Basecamp, Info, Walkies and 
          Adv Schedule here.
          </p>
          </Col>
          </Row>
          {/* callsheet info */}
          <Form className= {`mb-1 ${styles.White }`} onSubmit={handleSubmit}>
          {infoFields}
          {/* info button */}
          {/* <Row>
          <Col xs={6} >
          <Button
              className={`float-right py-0 mt-2 ${btnStyles.Order} ${btnStyles.Button}`}
              onClick={() => setShowImportantCrew(showImportantCrew => !showImportantCrew)} >Important
          </Button>
          </Col>
          </Row> */}
          {buttons}
          </Form>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default CallsheetEditPage2;
